import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { reset } from "../mutators";
import AuthAPI from "../../API/AuthAPI";
import { RootState } from "..";

interface UserPermissionState {
    userPermissionsList: string[];
}

const initialState: UserPermissionState = {
    userPermissionsList: [],
};

export const AuthSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        // Set State
        SET_USER_PERMISSIONS: (state, action) => {
            state.userPermissionsList = action.payload;
        },
        // Reset State
        AUTH_RESET: (state) => {
            reset(state, initialState);
        },
    },
});

// Getters
export const getUserPermissions = (state: RootState): string[] =>
    state.RootReducer.AuthReducer.userPermissionsList as string[];

// Actions
export const getCurrentUserPermissions = createAsyncThunk(
    `${import.meta.env.VITE_BFF_PROXY}/getCurrentUserPermissions`,
    async (_: void, { dispatch }) => {
        let userPermissions: string[] = [];

        await AuthAPI.getUserPermissions()
            .then((res) => (userPermissions = res.data.data))
            .catch((err) => {
                console.log(err);
                if (err.response.status === 500) {
                    window.location.href = `${
                        import.meta.env.VITE_BFF_PROXY
                    }/bff/login?returnUrl=${import.meta.env.VITE_SITE_BASE}`;
                    return "";
                }
            });
        dispatch(SET_USER_PERMISSIONS(userPermissions));
    }
);

export const { SET_USER_PERMISSIONS, AUTH_RESET } = AuthSlice.actions;

export default AuthSlice.reducer;
